
Date.prototype.Format = function (fmt) {
    let o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

function UtilWs() {
    this.wsType = null;
    this.wsOid = null;
    this.wsUrl = null;
    this.wsObj = null;
    this.lastRecMsgTime = null;
    this.checkInterval = null;
    this.reconnCounter = 0;
    this.sendCounter = 0;
    this.isDebug = true;
    this.isFinishedConnect = true;
}

UtilWs.HEART_BEAT_PERIOD_SEC = 60;

UtilWs.STATUS = {
    START_CONNECT: 1,			//Start connect
    CONNECT_FINISHED: 2,		//connect OK
    CONNECT_ERROR: -1,			//connect error

    START_CLOSE: 3,			//start close
    CONNECT_CLOSED: 4,		//connect closed

    SEND_OK: 5,				//send msg OK
    SEND_FAIL: -5,				//send msg error
},

	/**
	 * config the WS url ,must called before open
	 * @param {String} wsBaseUrl the base URL
	 * @param {String} wsType the WS type string
	 * @param {String} wsOid the WS client OID
	 */
    UtilWs.prototype.config = function (wsBaseUrl, wsType, wsOid) {
        this.wsBaseUrl = wsBaseUrl;
        this.wsType = wsType;
        this.wsOid = wsOid;
        this.wsUrl = wsBaseUrl + "/" + wsType + "/" + wsOid;
    }
/**
 * config all callback function for WS
 * @param {Function} whenConnChangedFun function with params:({code, info}),called when connect or send occurs.
 * @param {Function} whenOnMsgFun params function with params:JSONObject{defined by user},when received JSON MSG
 */
UtilWs.prototype.configCallBack = function (whenConnChangedFun, whenOnMsgFun) {
    this.whenConnChangedFun = whenConnChangedFun;
    this.whenOnMsgFun = whenOnMsgFun;

}

UtilWs.prototype.log = function (info) {
    if (!this.isDebug) {
        return;
    }
    var str = "[" + new Date().Format("hh:mm:ss") + "]:" + info;
    console.log(str);
};

/**
 * controller the console log debug logging or not
 * @param {Boolean} isDebugBool
 */
UtilWs.prototype.setDebug = function (isDebugBool) {
    this.isDebug = isDebugBool;
};


UtilWs.prototype.checkAndKeepWs = function () {
    if (!this.isFinishedConnect) {
        return;
    }
    if (this.wsObj && (this.wsObj.reaUtilState == WebSocket.CLOSING
        || this.wsObj.reaUtilState == WebSocket.CONNECTING)) {
        return;
    }
    var curDate = new Date();
    var isTimeOut = false;
    if (this.lastRecMsgTime) {
        var periodTime = (curDate.getTime() - this.lastRecMsgTime.getTime()) / 1000;
        isTimeOut = (periodTime > UtilWs.HEART_BEAT_PERIOD_SEC) ? true : false;
    }
    if (this.wsObj && this.wsObj.reaUtilState == WebSocket.OPEN) {
        if (isTimeOut) {
            this.log("TimeOut,Closing...");
            this.wsObj.close();
        }
        return;
    }

    this.reconnCounter++;
    this.log("Start connect...,No." + this.reconnCounter);
    var info = "开始连接...第 " + this.reconnCounter + " 次";
    if (this.whenConnChangedFun) {
        this.whenConnChangedFun({ code: UtilWs.STATUS.START_CONNECT, info });
    }

    this.isFinishedConnect = false;
    var wsTmpObj = new WebSocket(this.wsUrl);
    var fatherObj = this;
    wsTmpObj.onopen = function (evt) {
        fatherObj.wsObj = this;
        fatherObj.lastRecMsgTime == new Date();;
        fatherObj.log("connected");
        fatherObj.isFinishedConnect = true;
        var infoOk = "连接完成";
        if (fatherObj.whenConnChangedFun) {
            fatherObj.whenConnChangedFun({ code: UtilWs.STATUS.CONNECT_FINISHED, info: infoOk });
        }
    };

    wsTmpObj.onclose = function (evt) {
        fatherObj.log("closed");
        fatherObj.lastRecMsgTime = null;
        fatherObj.isFinishedConnect = true;
        var infoCLose = "连接关闭";
        if (fatherObj.whenConnChangedFun) {
            fatherObj.whenConnChangedFun({ code: UtilWs.STATUS.CONNECT_CLOSED, info: infoCLose });
        }
    };

    wsTmpObj.onmessage = function (evt) {
        fatherObj.lastRecMsgTime = new Date();
        fatherObj.log('[RECV]->' + evt.data);
        var json = JSON.parse(evt.data);
        if (json.t == "HB") {
            this.send(evt.data);
        }
        if (fatherObj.whenOnMsgFun) {
            fatherObj.whenOnMsgFun(json);
        }
    };

    wsTmpObj.onerror = function (evt) {
        fatherObj.log("ws error");
        fatherObj.lastRecMsgTime = null;
        fatherObj.isFinishedConnect = true;
        var infoError = "连接错误";
        if (fatherObj.whenConnChangedFun) {
            fatherObj.whenConnChangedFun({ code: UtilWs.STATUS.CONNECT_ERROR, info: infoError });
        }
    };
    this.log("Connect...over");
}
/**
 * Start open the WS start work
 */
UtilWs.prototype.open = function () {
    if (this.wsObj && this.wsObj.reaUtilState == WebSocket.OPEN) {
        this.log("current is opened.");
        return;
    }
    var info = "开始打开连接";
    if (this.whenConnChangedFun) {
        this.whenConnChangedFun({ code: UtilWs.STATUS.START_CONNECT, info });
    }
    this.checkAndKeepWs();
    var self = this;
    var checkFun = function () {
        self.checkAndKeepWs();
    }

    this.checkInterval = setInterval(checkFun, 5000);
};

/**
 * Closes the WS and ends all WS work,if you want to reopen it,must call open() again
 */
UtilWs.prototype.close = function () {
    if (this.checkInterval) {
        clearInterval(this.checkInterval);
    }
    var info = "开始关闭连接";
    if (this.whenConnChangedFun) {
        this.whenConnChangedFun({ code: UtilWs.STATUS.START_CLOSE, info: info });
    }

    if (this.wsObj && this.wsObj.reaUtilState == WebSocket.OPEN) {
        this.wsObj.close();
    }
};

/**
 * send one string to the WS server ,recomment user JSON string
 * @param {String} str the MSG string format
 */
UtilWs.prototype.sendText = function (str) {
    var info = "发送失败,请检查网络及登录状态";
    var code = UtilWs.STATUS.SEND_FAIL;
    if (this.wsObj && this.wsObj.reaUtilState == WebSocket.OPEN) {
        this.wsObj.send(str);
        this.sendCounter++;
        info = "发送成功:" + this.sendCounter;
        code = UtilWs.STATUS.SEND_OK;
    }
    if (this.whenConnChangedFun) {
        this.whenConnChangedFun({ code, info });
    }
};

/**
 * check if curent WS connect is OK
 */
UtilWs.prototype.isConn = function () {
    return (this.wsObj && this.wsObj.reaUtilState == WebSocket.OPEN);
};

export default {
    STATUS: UtilWs.STATUS,		//export the STATUS
    UtilWs: UtilWs,					//export the object, your must use 'new UtilWs()' to get one instance
};



// WEBPACK FOOTER //
// ./src/common/ws.js